module.exports = __webpack_public_path__ + "img/cimb.ab62e613.png";